/*
 * SPDX-FileCopyrightText: 2023 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useNoteTitle } from '../../../hooks/common/use-note-title'
import Head from 'next/head'
import React from 'react'

/**
 * Sets the note and app title for the browser window
 */
export const NoteAndAppTitleHead: React.FC = () => {
  const noteTitle = useNoteTitle()
  // const showDot = useHasMarkdownContentBeenChangedInBackground()

  // code to show dot in title when something change in editor
  // const noteAndAppTitle = useMemo(() => {
  //   return (showDot ? '(•) ' : '') + noteTitle + ' - ' + appTitle
  // }, [appTitle, noteTitle, showDot])

  return (
    <Head>
      <title>{noteTitle}</title>
      <meta name="robots" content="noindex, nofollow" />
    </Head>
  )
}
